import { useTranslation } from "@sagot/i18n";
import { ChoiceChips, Skeleton } from "@sagot/ui";
import { useId } from "react";
import { useAgentsList } from "../shared/use-shared-queries";

interface AgentPickerProps {
  value: readonly string[];
  onChange: (next: string[]) => void;
}

/** "Use in agents": the agents that will answer from the new source (the API checks `agents.edit` on each). */
export function AgentPicker({ value, onChange }: AgentPickerProps) {
  const { t } = useTranslation();
  const agents = useAgentsList();
  const hintId = useId();
  const heading = t("deployKnowledge.knowledge.add.agents");
  return (
    <div>
      <p className="label">{heading}</p>
      {agents.data ? (
        agents.data.length > 0 ? (
          <ChoiceChips
            multiple
            aria-label={heading}
            value={value}
            onValueChange={onChange}
            options={agents.data.map((agent) => ({ value: agent.id, label: agent.name }))}
          />
        ) : (
          <p className="text-xs text-fg-muted">{t("deployKnowledge.knowledge.add.agentsNone")}</p>
        )
      ) : agents.isError ? (
        <p className="text-xs text-fg-muted">{t("deployKnowledge.knowledge.add.agentsNone")}</p>
      ) : (
        <div className="flex gap-2" aria-hidden="true">
          <Skeleton className="h-8 w-28" />
          <Skeleton className="h-8 w-24" />
        </div>
      )}
      <p id={hintId} className="hint">
        {t("deployKnowledge.knowledge.add.agentsHint")}
      </p>
    </div>
  );
}
